// extracted by mini-css-extract-plugin
export default {"title":"Drivers_title__z2Sa9","content":"Drivers_content__AyBQy","itemName":"Drivers_itemName__TCDkl"};